<template lang="pug">
  self-layout
    template(#header)
      self-header
    template(#feed)
      self-feed
</template>

<script>
import { page } from '@iez/core'
import { mdiAccountGroup } from '@mdi/js'
import SelfLayout from './layout/'
import SelfHeader from './header/'
import SelfFeed from './feed/'

const route = {
  name: 'Actualité',
  path: '/news'
}

page.bottomNavigation.add({
  route,
  icon: mdiAccountGroup,
  position: 0
})

export default {
  ...route,

  components: {
    SelfLayout,
    SelfHeader,
    SelfFeed
  }
}
</script>
